export default __webpack_public_path__ + "static/media/elephant.eea565d3.jpg";